import React, { FC } from "react"
import Image from "gatsby-image"
//mui
import { makeStyles, Typography, Box, Grid, Button } from "@material-ui/core"
import FavoriteIcon from "@material-ui/icons/Favorite"
//icon
import CommentIcon from "../../../assets/images/comment.png"
//type
import { commentsType } from "../../../types/comment_TYPE"
import moment from "moment"

const useStyle = makeStyles(theme => ({
  iconsWrapper: {
    display: "flex",
  },
  flex: {
    display: "flex",
    paddingBottom: "10px",
  },
  icon: {
    color: theme.palette.primary.main,
    padding: "0 8px 0 0px",
    fontSize: "35px",
  },
  iconsText: {
    fontSize: "24px",
    fontWeight: 600,
    color: "#575757",
  },
  underline: {
    height: "1px",
    width: "100%",
    background: "#575757",
    marginTop: "10px",
    opacity: "0.3",
  },
  authorDetails: {
    display: "flex",
    alignItems: "center",
    padding: " 20px 0 20px 0",
    width: "100%",
  },
}))

interface props {
  Likes: number
  commentData: commentsType[]
}

const BlogComments: FC<props> = ({ Likes, commentData }) => {
  const classes = useStyle()

  //DATE FORMATTING LINKS
  // https://www.carlrippon.com/formatting-dates-and-numbers-in-react/
  // https://stackoverflow.com/questions/3552461/how-to-format-a-javascript-date/33131823

  //foramtting  Date Time
  function convertToLocalDatetime(dateTime) {
    //add code here to convert Pakistan time to the local date time
    const dateFormat = "MM-DD-YYYY"
    const testDateUtc = moment.utc(dateTime)
    const localDate = testDateUtc.local()
    const parsed_date = localDate.format(dateFormat)
    return parsed_date
  }

  const NumComents = commentData.length
  return (
    <div>
      <Box pt={8}>
        <Grid container className={classes.iconsWrapper}>
          <Grid item xs={12} sm={6} md={4}>
            <div className={classes.flex}>
              <FavoriteIcon className={classes.icon} />
              <Typography className={classes.iconsText} color="textSecondary">
                {Likes >= 10 ? Likes : "0" + Likes} Likes
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={8}>
            <div className={classes.flex}>
              <img
                src={CommentIcon}
                alt="comment Icons"
                style={{ width: "35px", height: "35px", paddingRight: "10px" }}
              />
              <Typography className={classes.iconsText} color="textSecondary">
                {NumComents >= 10 ? NumComents : "0" + NumComents} Comments
              </Typography>
            </div>
          </Grid>
        </Grid>
        <div className={classes.underline}></div>
      </Box>
      {commentData.map((comment: commentsType, i: number) => (
        <div key={i}>
          <div className={classes.authorDetails}>
            <Box pr={1}>
              <div style={{ width: "70px", height: "70px" }}>
                <Image
                  fluid={comment.authorComment.authorImage.fluid}
                  alt={comment.authorComment.authorName}
                ></Image>
              </div>
            </Box>

            <Box pl={1}>
              <Grid container direction="column">
                <Grid item>
                  <Box>
                    <Typography variant="subtitle1">
                      <b>{comment.authorComment.authorName}</b>
                    </Typography>
                  </Box>
                </Grid>
                <Grid item>
                  <Box>
                    <Typography color="textSecondary" variant="subtitle2">
                      {new Intl.DateTimeFormat("en", {
                        year: "numeric",
                        month: "long",
                        day: "2-digit",
                      }).format(
                        new Date(
                          convertToLocalDatetime(comment.commentDateTime)
                        )
                      )}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item>
                  <Box mt={1} mb={2}>
                    <Typography
                      style={{ color: "#575757" }}
                      variant="subtitle2"
                    >
                      <b>{comment.comment}</b>
                    </Typography>
                  </Box>
                </Grid>
                <Grid item container>
                  <Box pr={1}>
                    <Button
                      variant="contained"
                      disableElevation
                      size="small"
                      color="primary"
                    >
                      Reply
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </div>
          <div className={classes.underline}></div>
        </div>
      ))}
    </div>
  )
}

export default BlogComments
